'use strict'

// const mockMode = process.env.MOCKMODE

export function projectFilesService (instance) {
	const http = instance.http

	const service = {
		/**
		 * @param formData
		 */
		upload: function (formData) {
			return http.post(
				'/project-upload',
				formData,
				{ headers: { 'Content-Type': 'multipart/form-data' } }
			).then(function (resp) {
				let out = resp.result
				return out
			}).catch(response => {
				console.log('error uploading project files', response)
			})
		}
	}

	return service
}



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/services/project-files-service.js